// usePosts.ts - 게시글 목록 조회 커스텀 훅

import { useState, useEffect } from 'react';
import { getPostList, PostListResponse, BoardType } from '../services/postApi';
import { getMockDataByBoard } from '../utils/postMockData';

interface UsePostsParams {
  board: BoardType;
  page?: number;
  size?: number;
  lectureCategoryId?: number;
  lectureId?: number;
  chapter?: number;
  studyCategoryId?: number;
}

interface UsePostsReturn {
  data: PostListResponse | null;
  loading: boolean;
  error: string | null;
  refetch: () => void;
}

export const usePosts = ({
  board,
  page = 0,
  size = 20,
  lectureCategoryId,
  lectureId,
  chapter,
  studyCategoryId
}: UsePostsParams): UsePostsReturn => {
  const [data, setData] = useState<PostListResponse | null>(null);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState<string | null>(null);

  const fetchPosts = async () => {
    setLoading(true);
    setError(null);

    try {
      console.log(`게시글 목록 조회 시작 - board: ${board}, page: ${page}, size: ${size}`);
      
      // API 호출 시도
      const response = await getPostList(
        board,
        page,
        size,
        lectureCategoryId,
        lectureId,
        chapter,
        studyCategoryId
      );

      // console.log('API 응답 성공:', response);

      if (response.code === 200 && response.data) {
        setData(response.data);
      } else {
        throw new Error(response.message || 'API 응답 오류');
      }
    } catch (apiError) {
      console.warn('API 호출 실패, 더미 데이터 사용:', apiError);
      
      // API 실패 시 더미 데이터 사용
      const mockData = getMockDataByBoard(board, page, size);
      setData(mockData);
      
      // 에러는 설정하지 않음 (더미데이터로 대체되었으므로)
      setError(null);
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    fetchPosts();
  }, [board, page, size, lectureCategoryId, lectureId, chapter, studyCategoryId]);

  const refetch = () => {
    fetchPosts();
  };

  return {
    data,
    loading,
    error,
    refetch
  };
};
